// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rating-box[data-v-0ba5d8a4] .img-not-loaded,.rating-star[data-v-0ba5d8a4] .img-not-loaded{height:10px!important;width:64px!important}@media only screen and (min-width:1264px){.rating-box[data-v-0ba5d8a4] .img-not-loaded,.rating-star[data-v-0ba5d8a4] .img-not-loaded{height:23px!important;width:138px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
